import type { BaseItem } from '@coursera-web/cds-labs';
import type { Specialization_Specialization as S12n } from '__generated__/graphql-types-do-not-use';

import type { SpotlightComplexCollectionQuery } from 'bundles/page-config-common/queries/__generated__/SpotlightComplexCollection';

export type Pathway = BaseItem & {
  items: S12n[];
};

type SpotlightComplexCollectionData = NonNullable<
  SpotlightComplexCollectionQuery['Recommendations']
>['queryCollection'];

export function toPathway(recommendationCollection: SpotlightComplexCollectionData): Pathway {
  const pcs =
    recommendationCollection.entities?.elements.filter(Boolean).filter((x) => {
      return x?.__typename === 'ProductCard_ProductCard';
    }) ?? [];

  const is = pcs
    .filter(Boolean)
    .map((pathway) => {
      if (pathway.productTypeAttributes.__typename === 'ProductCard_Specialization') {
        return pathway.productTypeAttributes.canonical.latestSpecialization as S12n;
      } else {
        return null;
      }
    })
    .filter(Boolean);

  return { id: recommendationCollection.id, items: is };
}
